import React from 'react';
import MainScreen from './screens/MainScreen';
import { CssBaseline } from '@material-ui/core';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Login from './screens/Login';
import { createMuiTheme } from '@material-ui/core/styles';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import grey from '@material-ui/core/colors/grey';
import amber from '@material-ui/core/colors/amber';
import ProtectedRoute from './components/ProtectedRoute';
import { trySetApiKey } from './utils/apiKey';

const theme = createMuiTheme({
  palette: {
    primary: amber,
    secondary: grey
  }
});

class App extends React.Component {

  componentWillMount() {
    trySetApiKey();
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
            <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
              <Switch>
                <Route exact path="/login" component={Login} />
                <ProtectedRoute path="/" component={MainScreen}/>
              </Switch>
            </div>
        </BrowserRouter>
      </MuiThemeProvider>
    );
  }
}

export default App;